export default "__VITE_ASSET__BjzmWOJz__"